import { BBModel } from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';

const category = {
    async query(company) {
        if (company.$has('categories')) {
            const resource = await company.$get('named_categories');
            const categories = await resource.$get('categories');

            return categories.map((category, index) => new BBModel.Category(category, index));
        } else {
            return Promise.reject('No categories found.');
        }
    },

    async queryById(company, id) {
        return (await category.query(company)).find(category => category.id === id);
    },

    async queryByParent(params={}) {
        const baseUri = `${context.apiUrl}/api/${context.apiVersion}`;
        const resource = await halClient.$get(baseUri);

        if (resource.$has('categories')) {
            if (!params.category) {
                return await resource.$get('categories', params);
            } else {
                return await params.category.$get('children', params);
            }
        }
    }
};

export {
    category
};
